export default __webpack_public_path__ + "static/media/cj-logo-2021.6808c0c5.svg";